// src/App.jsx
import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LoadingOverlay from "./components/LoadingOverlay";
import './main.css';

const IndexPage = lazy(() => import('./pages/IndexPage'));
const TwoDHMVPage = lazy(() => import('./pages/TwoDHMVPage'));
const ThreeDHMVPage = lazy(() => import('./pages/ThreeDHMVPage'));
const SearchResultsPage = lazy(() => import('./pages/SearchResultsPage'));
const VideoPage = lazy(() => import('./pages/VideoPage'));


const App = () => {
  return (
    <BrowserRouter>
          <Suspense fallback={<LoadingOverlay isLoading={true} isBlocking={true} />}>
            <Routes>
              <Route path="/" element={<IndexPage />} />
              <Route path="/2d_hmv" element={<TwoDHMVPage />} />
              <Route path="/3d_hmv" element={<ThreeDHMVPage />} />
              <Route path="/search" element={<SearchResultsPage />} />
              <Route path="/video/:name2" element={<VideoPage />} />
            </Routes>
          </Suspense>
      </BrowserRouter>
  );
};

export default App;
